import { FormEntry } from "../../../types/types";
import { formMappings } from "../../../config/formMappings";
import { formFields } from "../../../services/form_fields";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

export default function EmergencyInfoCard(props: { entry: FormEntry }) {
  // Get form mapping from Redux state
  const activeFormName = useSelector(
    (state: RootState) => state.activeForm.activeFormName
  );
  const formMapping =
    formMappings[activeFormName as keyof typeof formMappings];

  // Get field keys from formMappings
  const emergencyContactNameFieldKey =
    formMapping?.fieldMappings?.["Emergency Contact Name"];
  const emergencyContactPhoneFieldKey =
    formMapping?.fieldMappings?.["Emergency Contact Phone"];

  // For v1, the API service maps field keys to human-readable names
  // For v2, the field keys remain as-is (not in form_fields.ts)
  // So we need to check both the field key and the human-readable name
  let emergencyContactName = "";
  let emergencyContactPhone = "";

  if (emergencyContactNameFieldKey) {
    // Check if API service mapped it to human-readable name
    const humanReadableName = formFields[emergencyContactNameFieldKey]?.name;
    if (humanReadableName && props.entry.meta[humanReadableName]) {
      // v1: Use human-readable name (API service mapped it)
      emergencyContactName = props.entry.meta[humanReadableName] || "";
    } else {
      // v2: Use raw field key (not mapped by API service)
      emergencyContactName =
        props.entry.meta[emergencyContactNameFieldKey] || "";
    }
  }

  if (emergencyContactPhoneFieldKey) {
    // Check if API service mapped it to human-readable name
    const humanReadableName = formFields[emergencyContactPhoneFieldKey]?.name;
    if (humanReadableName && props.entry.meta[humanReadableName]) {
      // v1: Use human-readable name (API service mapped it)
      emergencyContactPhone = props.entry.meta[humanReadableName] || "";
    } else {
      // v2: Use raw field key (not mapped by API service)
      emergencyContactPhone =
        props.entry.meta[emergencyContactPhoneFieldKey] || "";
    }
  }

  return (
    <div className="overflow-hidden bg-white shadow rounded-lg col-span-2">
      <div className="px-4 py-6 sm:px-6">
        <h3 className="text-base/7 font-semibold text-gray-900">
          Emergency Contact Info
        </h3>
        <p className="mt-1 max-w-2xl text-sm/6 text-gray-500">
          Emergency contact information of the group.
        </p>
      </div>
      <div className="border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-900">Contact Name</dt>
            <dd className="mt-1 text-lg/6 text-gray-700 sm:col-span-2 sm:mt-0">
              {emergencyContactName}
            </dd>
          </div>
          <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-900">Phone Number</dt>
            <dd className="mt-1 text-lg/6 text-gray-700 sm:col-span-2 sm:mt-0">
              {emergencyContactPhone ? (
                <a
                  href={`tel:${emergencyContactPhone}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {emergencyContactPhone}
                </a>
              ) : (
                ""
              )}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
